// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import AlertCircleFill from "@store/Library/Components/Toolkit/Icons/AlertCircle/AlertCircleFill";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import { FC, useContext } from "react";
import { css } from "styled-components";

interface Props extends WidgetProps {}

export interface OrderDetailsOutOfCycleStyles {
    orderOutOfCycleWrapper?: InjectableCss;
    orderOutOfCycleMessageIcon?: IconPresentationProps;
    orderOutOfCycleMessageText?: InjectableCss;
}

export const orderDetailsOutOfCycleStyles: OrderDetailsOutOfCycleStyles = {
    orderOutOfCycleWrapper: {
        css: css`
            display: flex;
            width: 100%;
            align-items: center;
            background-color: ${getColor("info.light")};
            padding: ${pxToRem(5, 10)};
            margin-top: ${pxToRem(10)};
        `,
    },
    orderOutOfCycleMessageIcon: {
        src: AlertCircleFill,
        color: "info.main",
        css: css`
            margin-right: ${pxToRem(10)};
        `,
    },
    orderOutOfCycleMessageText: {
        css: css`
            color: ${getColor("info.main")};
            font-weight: ${x => x.theme.design.typography.weight.bold};
        `,
    },
};

const styles = orderDetailsOutOfCycleStyles;

const OrderDetailsOutOfCycle: FC<Props> = () => {
    const { value: order, isLoading } = useContext(OrderStateContext);

    if (!order || isLoading || order.properties.wasRequestedOutOfCycle !== "True") {
        return null;
    }

    return (
        <StyledWrapper {...styles.orderOutOfCycleWrapper}>
            <Icon {...styles.orderOutOfCycleMessageIcon}></Icon>
            <Typography data-test-selector="outofcyclenotice" {...styles.orderOutOfCycleMessageText}>
                {translate("This order was requested out of cycle")}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsOutOfCycle,
    definition: {
        group: "Order Details",
        displayName: "Order Details Out Of Cycle Notice",
        allowedContexts: ["OrderDetailsPage"],
    },
};

export default widgetModule;
